import { LOCAL_PICKUP_DELIVERY_TIME } from '../constants/stores'

export const filterPoints = (points, localPoints) => {
  if (!localPoints.disabled && !localPoints.points.length) {
    return points
  } else if (localPoints.disabled) {
    return points.filter((p) => p?.properties?.type !== 'owned')
  } else {
    const finalPoints = points.filter((point) => {
      if (point.properties.type !== 'owned') {
        return true
      }
      const match = localPoints.points.some(
        (shopifyPoint) => point.properties.cmsId === shopifyPoint
      )
      return match
    })

    return finalPoints
  }
}

export const checkLocations = (edges, variantQuantity) => {
  const points = edges
    .map((point) => {
      if (point.node.available >= variantQuantity) {
        return point.node.location.id
      }
      return false
    })
    .filter((point) => point)
  return points
}

export const matchProductsLocations = (points) => {
  const match = points.reduce((a, b) => a.filter((c) => b.includes(c)))
  return match
}

export const editDeliveryTimeLocalPickup = (points, companyName) => {
  return points.map((point) => {
    if (LOCAL_PICKUP_DELIVERY_TIME[companyName]) {
      point.properties.deliveryTime = LOCAL_PICKUP_DELIVERY_TIME[companyName]
    }
    return point
  })
}

export const splitPointsByType = (points) =>
  points.reduce(
    (acc, point) => {
      acc[point.properties.type === 'owned' ? 0 : 1].push(point)
      return acc
    },
    [[], []]
  )

export const changePointsDetails = (points) => {
  if (points) {
    points.forEach((point) => {
      point.properties.schedules.map((schedule, index) => {
        return (point.properties.schedules[index] = schedule.replace(
          'Cerrado',
          'No Disponible'
        ))
      })
    })
  }
  return points
}

const parseTime = (hour) => {
  if (hour.length > 5) return hour.slice(0, 5)
  return hour
}

export const parseBusinessHoursVTEX = (businessHours) => {
  const schedule = []
  const businessDays = businessHours.filter((day) => day.DayOfWeek > 0 && day.DayOfWeek < 6)
  schedule.push(`Lun-Vie: ${parseTime(businessDays[0].OpeningTime)}-${parseTime(businessDays[0].ClosingTime)}`)
  const saturday = businessHours.filter((day) => day.DayOfWeek === 6)
  const sunday = businessHours.filter((day) => day.DayOfWeek === 0)
  if (saturday[0].OpeningTime === sunday[0].OpeningTime && saturday[0].ClosingTime === sunday[0].ClosingTime) {
    schedule.push(`Sáb-Dom: ${parseTime(saturday[0].OpeningTime)}-${parseTime(saturday[0].ClosingTime)}`)
  } else {
    schedule.push(`Sáb: ${parseTime(saturday[0].OpeningTime)}-${parseTime(saturday[0].ClosingTime)}`)
    schedule.push(`Dom: ${parseTime(sunday[0].OpeningTime)}-${parseTime(sunday[0].ClosingTime)}`)
  }
  return schedule
}
